export const nullNoop = () => null;

export default () => {};
